const INTAKE_COMPLETED_PREFIX = 'capio-engage-intake-completed';

export function intakeCompletedStorageKey(
  institutionId: string,
  sessionId: string
): string {
  return `${INTAKE_COMPLETED_PREFIX}:${institutionId}:${sessionId}`;
}

export function isIntakeCompleted(
  institutionId: string,
  sessionId: string
): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return (
      localStorage.getItem(
        intakeCompletedStorageKey(institutionId, sessionId)
      ) === '1'
    );
  } catch {
    return false;
  }
}

export function markIntakeCompleted(
  institutionId: string,
  sessionId: string
): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(
      intakeCompletedStorageKey(institutionId, sessionId),
      '1'
    );
  } catch {
    // ignore quota / private mode
  }
}
